import { NextResponse } from 'next/server'
import type { NextRequest } from 'next/server'
import { redirectBaseOnUserRole, permissionsByRole, DY_COOKIE_SESSION } from '@/utils'
// HOSTNAME, DEV

export const checkIfPublicPath = (pathname) => {
  if (pathname.startsWith('/login') ||
      pathname.startsWith('/signup') ||
      pathname.startsWith('/reset-password') ||
      pathname.startsWith('/404') ||
      pathname.startsWith('/not-found') ||
      pathname.startsWith('/mantenimiento') ||
      pathname.startsWith('/pdf')) {
    return true
  }
}

export const checkIfLegalPath = (pathname) => {
  if (pathname.startsWith('/rgpd') ||
      pathname.startsWith('/condiciones-de-uso') ||
      pathname.startsWith('/politica-de-privacidad') ||
      pathname.startsWith('/acuerdo-comercial')) {
    return true
  }
}

const checkIfPdfPath = (pathname) => {
  return pathname.startsWith('/pdf')
}

function validateBasicAuthPdf(header) {
  const authValue = header.split(' ')[1]
  const [user, pwd] = atob(authValue).split(':')
  return (user === process.env.BASIC_AUTH_PDF_USER && pwd === process.env.BASIC_AUTH_PDF_PASSWORD)
}


// This function can be marked `async` if using `await` inside
export default async function proxy(req: NextRequest) {
  const nextUrl = req.nextUrl
  // Redirect to maintenance page if the app is in maintenance mode
  const maintenance = process.env.DY_MAINTENANCE === 'true'
  if (maintenance) {
    if(nextUrl.pathname !== '/mantenimiento') {
      return NextResponse.redirect(new URL('/mantenimiento', req.url))
    } else {
      const response = NextResponse.next()
      return response
    }
  }

  // BASIC AUTH for PDF files
  if (checkIfPdfPath(nextUrl.pathname)) {
    const basicAuthHeader = req.headers.get('authorization') || req.headers.get('Authorization')
    const basicAuthPassed = !basicAuthHeader ? false : validateBasicAuthPdf(basicAuthHeader)

    if (!basicAuthPassed) {
      nextUrl.pathname = '/api/auth/basic'
      return NextResponse.rewrite(nextUrl)
    }

    return NextResponse.next()
  }
  // END BASIC AUTH for PDF files


  const userCookie = req.cookies.get(DY_COOKIE_SESSION)
  const isPublicPath = checkIfPublicPath(req.nextUrl.pathname)
  const isLegalPath = checkIfLegalPath(req.nextUrl.pathname)

  if(isPublicPath && userCookie) {
    const href = redirectBaseOnUserRole(userCookie, null, true)
    return NextResponse.redirect(new URL(href, req.url))
  } else if (!isPublicPath && !isLegalPath && !userCookie) {
    // ❌ Trying to access a private path without credentials'
    return NextResponse.redirect(new URL('/login', req.url))
  } else if (!isPublicPath && !isLegalPath  && userCookie) {
    // 🟢 !isPublicPath && userCookie >>> checking ROLES permissions'
    const userData = JSON.parse(userCookie.value)
    const role = userData?.user?.role
    console.info('🛡️ role', role)
    if (!role) return NextResponse.redirect(new URL('/login', req.url))
    const permissionGranted = permissionsByRole[role].some(value => req.url.includes(value))
    if (!permissionGranted) {
      const href = redirectBaseOnUserRole(userCookie, null, true)
			console.log(`proxy redirecting by role ${role} to ${href}`)
      return NextResponse.redirect(new URL(href, req.url))
    }
  }
}

/**
 * Match all request paths except for:
 * - api (API routes)
 * - _next/static (files in static folder)
 * - _next/image  (image optimization files)
 * - .well-known folder
 * - images folder
 * - videos folder
 * - docs folder)
 * - favicon.ico
 * - robots.txt
 * - sitemap.xml
 * - manifest.json
 * - .ttf files
 * - .woff2 files
 * - .svg files
 * - .jpg files
 * - .png files
**/
export const config = {
  matcher: [
    '/((?!api|_next/static|_next/image|.well-known|images|videos|docs|json|favicon.ico|robots.txt|sitemap.xml|manifest.json|manifest.webmanifest|.*\\.ttf|.*\\.woff2|.*\\.svg|.*\\.jpg|.*\\.png|.*\\.gif|.*\\.webp|.*\\.avif|.*\\.mp4|.*\\.webm$).*)',
  ]
}
